import { getInternalOrganizationMasterServiceAgreementDetailsApi } from '@/api/v1/organization/internal/getInternalOrganizationMasterServiceAgreementDetailsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const getInternalOrganizationMasterServiceAgreementDetails = async () => {
  try {
    const response = await getInternalOrganizationMasterServiceAgreementDetailsApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
